import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";
//IMAGES

export const HeaderContainer = styled.header`
  font-family: 'Outfit', sans-serif;
  padding: 20px 0px;
  background-color: #fff;
  z-index: 9999;
  position: relative;
  .header_logo {
    display: flex;
    align-items: center;
    svg {
      height: 50px;
      width: auto;
    }
  }

  .header_navs_menu {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-start;
      gap: 34px;
      padding: 0;
      margin: 0;
      @media screen and (max-width: 1320px) {
        gap: 20px;
      }

      li {
        a {
          text-decoration: none;
          font-weight: 300;
          color: #333;
          transition: color 0.3s ease;

          &:hover {
            color: ${COLORS.AccentRed};
          }
        }
        span{
          text-decoration: none;
          font-weight: 300;
          color: #333;
          transition: color 0.3s ease;

          &:hover {
            color: ${COLORS.AccentRed};
          }
        }
      }
    }
  }
  .active {
    color: ${COLORS.AccentRed} !important;
  }
  .menu_other_buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;
    .social_handles  {
      ul{
        padding: 0 !important;
        display: flex;
        align-items: center;
        list-style: none;
        li{
          padding: 0 11px;
          a{
            line-height: 1;
            display: block;
            &:hover{
              svg path:first-child{
                fill: ${COLORS.PrimaryBlue};
              }
            }
          }
          span{
            line-height: 1;
            display: block;
            &:hover{
              svg path:first-child{
                fill: ${COLORS.PrimaryBlue};
              }
            }
          }
        }
      }
    }
    .portal_login_link {
      padding: 0 10px;
      a {
        color: #000;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          font-family: 'Outfit', sans-serif;
          text-decoration: unset;
          line-height:1.1;
            @media screen and (max-width: 1320px) {
              font-size: 15px;
            }
        &:hover {
          text-decoration: unset;
          color: ${COLORS.AccentRed};
        }
      }
      span{
          color: #000;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          font-family: 'Outfit', sans-serif;
          text-decoration: unset;
          line-height:1.1;
            @media screen and (max-width: 1320px) {
              font-size: 15px;
            }
        &:hover {
          text-decoration: unset;
          color: ${COLORS.AccentRed};
        }
      }
  }


  /* Responsive Breakpoints */
  @media (max-width: 768px) {
    .header_navs_menu ul {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }

    .menu_other_buttons {
      flex-direction: column;
      gap: 10px;
    }
  }
`;

